import { ProductBrand } from 'types/product-brands';
import { ProductType } from 'types/productTypes';

export const formatSelectFieldCompliantList = (list: Array<ProductType | ProductBrand>) => {
  return list.map(function (row: ProductType | ProductBrand) {
    return { value: row.id.toString(), name: row.name, id: row.id, label: row.name };
  });
};
